var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"award-text"},[_c('div',{staticClass:"main"},[_c('i',{staticClass:"fas fa-award"}),_vm._v(" "+_vm._s(_vm.content.description)+" ")]),_c('div',{staticClass:"result"},[_vm._v(">>> "+_vm._s(_vm.content.get))])])}
var staticRenderFns = []

export { render, staticRenderFns }